/**
 * Readable message from Axios error response bodies (Nest/FastAPI/Express variants).
 */
export function formatApiError(err) {
	const d = err?.response?.data;
	if (d === undefined || d === null) return String(err?.message || "Request failed");
	if (typeof d === "string") return d;
	if (typeof d?.message === "string" && d.message.length) return d.message;
	const detail = d?.detail ?? d?.error_description ?? d?.error;
	if (typeof detail === "string") return detail;
	if (Array.isArray(detail)) {
		return detail
			.map((x) => {
				if (typeof x === "string") return x;
				if (x && typeof x === "object" && "msg" in x) return String(x.msg);
				return JSON.stringify(x);
			})
			.join("; ");
	}
	if (typeof d?.error === "string") return d.error;
	try {
		const s = JSON.stringify(d);
		if (s && s !== "{}") return s;
	} catch {}
	return String(err?.message || "Request failed");
}
